import React from 'react'
import moment from 'moment'
import { defaultDateFormat, formatDate } from '@/utils/dateUtilities'

function DataCrossingsCustomCellMultiple (props) {
  const { dataItem, fieldName, locale } = props

  const nameSelector = locale === 'en' ? 'latinName' : 'name'
  return (
    <td>
      {dataItem.individuals.map((x, i) =>
        <React.Fragment key={i}>
          {i > 0 ? <hr /> : null}
          <div>
            {x.relatedInstitutions.length
              ? x.relatedInstitutions.map(y => y[fieldName] && y[fieldName][nameSelector] ? y[fieldName][nameSelector] : '')
                .filter(x => x).join(', ')
              : '\u00A0'}
          </div>
        </React.Fragment>)}
    </td>
  )
}

function customCellMultipleExport ({ dataItem, field, localizeValue, additionalProps }) {
  const nameSelector = localizeValue()
  const fieldName = (additionalProps && additionalProps.fieldName) || field

  return dataItem.individuals.map(x =>
    x.relatedInstitutions.length
      ? x.relatedInstitutions.map(y => y[fieldName] && y[fieldName][nameSelector] ? y[fieldName][nameSelector] : '')
        .filter(x => x).join(', ')
      : '\u00A0'
  ).join('\n')
}

function DataCrossingsCustomCellSimple (props) {
  const { dataItem, fieldName, locale } = props

  const nameSelector = locale === 'en' ? 'latinName' : 'name'
  return (
    <td>{dataItem.individuals.map((x, i) =>
      <React.Fragment key={i}>
        {i > 0 ? <hr /> : null}
        <div>{x[fieldName] ? x[fieldName][nameSelector] : '\u00A0'}</div>
      </React.Fragment>)}
    </td>
  )
}

function customCellSimpleExport ({ dataItem, field, localizeValue, additionalProps }) {
  const nameSelector = localizeValue()
  const fieldName = (additionalProps && additionalProps.fieldName) || field

  return {
    value: dataItem.individuals.map(x => x[fieldName] ? x[fieldName][nameSelector] : '\u00A0').join('\n'),
    _height: dataItem.individuals.length * 20
  }
}

function getDate (value) {
  if (value) {
    const d = moment(value)
    if (d.isValid()) {
      return (formatDate(d, defaultDateFormat))
    }
  }
}

function DataCrossingsCustomDateCell (props) {
  const { dataItem, fieldName } = props

  return (
    <td>{dataItem.individuals.map((x, i) =>
      <React.Fragment key={i}>
        {i > 0 ? <hr /> : null}
        <div>{x[fieldName] ? getDate(x[fieldName]) : '\u00A0'}</div>
      </React.Fragment>)}
    </td>
  )
}

function customCellDateExport ({ dataItem, field }) {
  return dataItem.individuals.map(x =>
    x[field] ? getDate(x[field]) : '\u00A0'
  ).join('\n')
}

export {
  DataCrossingsCustomCellMultiple,
  DataCrossingsCustomCellSimple,
  DataCrossingsCustomDateCell,
  customCellMultipleExport,
  customCellSimpleExport,
  customCellDateExport
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/dataCrossing/customCell.js